import { component } from '../../framework/component.decorator';
import { circle } from '../../templating/circle.element';
import { div } from '../../templating/div.element';
import { style } from '../../templating/style.element';
import { svg } from '../../templating/svg.element';
import { BaseComponent } from '../../framework/base.component';
import styles from './progress-ring.component.scss';
import { OnChange } from '../../framework/on-change.interface';
import { OnInit } from '../../framework/on-init.interface';

@component({
  selector: 'app-progress-ring',
  styles,
})
export class ProgressRingComponent
  extends BaseComponent<ProgressRingComponent>
  implements OnChange, OnInit
{
  static get observedAttributes() {
    return ['progress'];
  }

  private _circumference: number;

  constructor() {
    super(ProgressRingComponent);
  }

  async createInitialComponent() {
    const stroke = this.getAttribute('stroke');

    if (!stroke) return [];

    const radius = this.getAttribute('radius');

    if (!radius) return [];

    const parsedRadius = parseInt(radius, 10);

    const normalizedRadius = parsedRadius - parseInt(stroke, 10) * 2;
    this._circumference = normalizedRadius * 2 * Math.PI;

    const cssOverrides = `.wrapper {
      height: ${parsedRadius * 2}px;
      width: ${parsedRadius * 2}px;
    }
    .wrapper .value {
      height: ${parsedRadius * 2}px;
      width: ${parsedRadius * 2}px;
    }`;
    const style$ = style({
      onCreate: (e) => (e.innerHTML = cssOverrides),
    });

    return [
      style$,
      div('wrapper', [
        div('value', { textContent: '0%' }),
        svg(
          {
            attributes: {
              height: (parsedRadius * 2).toString(),
              width: (parsedRadius * 2).toString(),
            },
          },
          [
            circle({
              attributes: {
                stroke: 'rgba(0, 0, 0, 0.25)',
                'stroke-dasharray': `${this._circumference} ${this._circumference}`,
                style: `stroke-dashoffset: ${this._circumference}`,
                'stroke-width': stroke,
                fill: 'transparent',
                r: normalizedRadius,
                cx: radius,
                cy: radius,
              },
            }),
          ]
        ),
      ]),
    ];
  }

  async onInit() {
    this.setProgress(0);
  }

  setProgress(percent: string | number) {
    const parsedPercent = parseFloat(percent.toString());
    const offset =
      this._circumference - (parsedPercent / 100) * this._circumference;
    const circle = this._root.querySelector<SVGCircleElement>('circle');

    if (!circle) return;

    circle.style.strokeDashoffset = offset.toString();

    const value = this._root.querySelector<HTMLDivElement>('.wrapper .value');

    if (!value) return;

    value.textContent = `${Math.round(parsedPercent)}%`;
  }

  async onChange(name: string, oldValue: string, newValue: string) {
    if (name === 'progress') {
      this.setProgress(newValue);
    }
  }
}
